'use client';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

const useErrorBoundary =
	process.env.NEXT_PUBLIC_USE_BUGSNAG_BOUNDARY &&
	process.env.NEXT_PUBLIC_USE_BUGSNAG_BOUNDARY === 'true' &&
	process.env.NEXT_PUBLIC_BUGSNAG_KEY;

if (useErrorBoundary && !Bugsnag.isStarted()) {
	Bugsnag.start({
		apiKey: process.env.NEXT_PUBLIC_BUGSNAG_KEY ?? '',
		plugins: [new BugsnagPluginReact()],
		appVersion: process.env.NEXT_PUBLIC_APP_VERSION,
		releaseStage: process.env.NEXT_PUBLIC_RELEASE_STAGE || process.env.NODE_ENV || 'development',
		collectUserIp: true,
	});
}

export const BugsnagErrorBoundary =
	useErrorBoundary && Bugsnag.getPlugin('react')
		? Bugsnag.getPlugin('react')!.createErrorBoundary(React)
		: ({ children }: { children: React.ReactNode }) => children;
